// extracted by mini-css-extract-plugin
export default {"addRoomButtonContainer":"RoomLayoutSelectorForm_addRoomButtonContainer__d1IW-"};